import axios from 'axios';
import { jwtDecode } from 'jwt-decode';
import { store } from '../ReduxToolkit/Store';
import { logout } from '../ReduxToolkit/Reducers/AdminAuthSlice';

const api = axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URL,
});

// Add an interceptor to inject token for all requests
api.interceptors.request.use(
    (config: any) => {
        const token = localStorage.getItem('crmtoken');
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);


let isHandlingSessionExpiry = false;

api.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error?.response?.status === 401 && !isHandlingSessionExpiry) {
            isHandlingSessionExpiry = true;

            store.dispatch(logout());
            localStorage.removeItem('crmtoken');
            localStorage.removeItem('crmsessiontime');

            window.location.href = `${process.env.PUBLIC_URL}/CRMLogin?sessionExpired=1`;
        }
        return Promise.reject(error);
    }
);

// Helper function to decode token
export const decodeToken = () => {
    const token = localStorage.getItem('crmtoken');
    if (token) {
        return jwtDecode(token);
    }
    return null;
};

export default api;